/*It creates a shared Vue instance that acts as an event bus — components emit events on it (nudgeBus.$emit('show-nudge', ...)) 
and the NudgeMessage component listens to it.
*/
import Vue from 'vue'

export const nudgeBus = new Vue()



// WEBPACK FOOTER //
// ./src/utils/nudgeBus.js